const helper = {
    mainNav: jQuery('#main-navbar'),
    searchNav: jQuery('#search-nav-bar'),
    searchNavContent: jQuery('#search-nav-bar-content'),
    navItemDropDown: jQuery('a.navbarDropdownMenuLink'),
    bgWhiteClass: 'bg-white',
    shadowBottomClass: 'shadow-bottom',
    shadowBottomImportantClass: 'shadow-bottom-important',
    ariaExpandedAttribute: 'aria-expanded',
    mobileNavClass: 'mobile-nav'
};

const handleToggleNavigationBackgroundOnSearchClickWithBgImg = () => {
    if (helper.mainNav.hasClass(helper.bgWhiteClass) && !helper.searchNav.hasClass(helper.bgWhiteClass)) {
        helper.mainNav.toggleClass(helper.bgWhiteClass);
        helper.mainNav.toggleClass(helper.shadowBottomImportantClass);
    }
    helper.mainNav.toggleClass(helper.bgWhiteClass);
    helper.searchNav.toggleClass(helper.bgWhiteClass);
    helper.searchNavContent.toggleClass(helper.shadowBottomClass);
};

const handleToggleNavigationBackgroundOnSearchClickNoBgImg = () => {
    helper.searchNav.toggleClass(helper.bgWhiteClass);
    helper.searchNavContent.toggleClass(helper.shadowBottomClass);
};

const addClassesOnMobileMenu = () => jQuery('#main-navbar-dropdown-toggler').on('click', (i) => {
    $(document).on("click", function(event) {
        var $trigger = $(".navbar-nav");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            const listItems = $('#main-navbar li.nav-item');
            listItems.each((i, e) => {
                $(e).addClass('row');
                if ($(e).hasClass('dropdown')) {
                    $(e.children[0]).addClass('col-10');
                    $(e.children[1]).addClass('col-2');
                    $(e.children[2]).addClass('col-12 bg-light');
                    $(e.children[1]).addClass('fa-plus').removeClass('fa-minus');
                }
            });
        }
    });
});

const handleExpandClick = () => jQuery('.dropdown-button').on('click', (i) => {
    var listItems = $('#main-navbar li.nav-item');
    listItems.each((index, e) => {
        if ($(e).hasClass('dropdown')) {
            $(e.children[1]).addClass('fa-plus').removeClass('fa-minus');
        }
    });

    if ($(i.currentTarget).parent().hasClass('show')) {
        $(i.currentTarget).addClass('fa-plus').removeClass('fa-minus');
    } else {
        $(i.currentTarget).addClass('fa-minus').removeClass('fa-plus');
    }
});

const enableToggleNavigationBackgroundOnSearchClick = () => jQuery('#search-toggle-link').on('click', () => {
    helper.mainNav.hasClass('has-image') ?
        handleToggleNavigationBackgroundOnSearchClickWithBgImg() :
        handleToggleNavigationBackgroundOnSearchClickNoBgImg();
});

const enableToggleNavigationBackgroundOnDesktopMenuDropdownClick = () => jQuery('#main-navbar a.navbarDropdownMenuLink').not('a.mobile-nav').on('click', function(e) {
    if ($(this).hasClass(helper.mobileNavClass)) {
        return;
    }
    const expanded = $(this).attr(helper.ariaExpandedAttribute);

    $(window).off('click').on('click', () => {
        // Toggle main nav bg if clicked outside of main nav
        if (helper.mainNav.hasClass(helper.bgWhiteClass) && !helper.searchNav.hasClass(helper.bgWhiteClass)) {
            helper.mainNav.toggleClass(helper.bgWhiteClass);
            if (helper.mainNav.hasClass('has-image')) {
                helper.mainNav.toggleClass(helper.shadowBottomImportantClass);
            }
        }
    });

    if (expanded === 'true' || !helper.mainNav.hasClass(helper.bgWhiteClass)) {
        if (!helper.searchNav.hasClass(helper.bgWhiteClass)) {
            helper.mainNav.toggleClass(helper.bgWhiteClass);
            if (helper.mainNav.hasClass('has-image')) {
                helper.mainNav.toggleClass(helper.shadowBottomImportantClass);
            }
        }
    }
});

const enableToggleNavigationBackgroundOnMobileMenuDropdownClick = () => jQuery('#main-navbar-dropdown-toggler').on('click', () => {
    const menuCurrentlyCollapsing = $('.navbar-collapse').hasClass('collapsing');
    if (menuCurrentlyCollapsing) {
        return;
    }
    helper.navItemDropDown.toggleClass(helper.mobileNavClass);
    helper.mainNav.toggleClass(helper.bgWhiteClass);
});

export const enablejQueryClassTogglingInMainNavigation = () => {
    enableToggleNavigationBackgroundOnSearchClick();
    enableToggleNavigationBackgroundOnDesktopMenuDropdownClick();
    enableToggleNavigationBackgroundOnMobileMenuDropdownClick();
    handleExpandClick();
    addClassesOnMobileMenu();
};

const fontSizeSwitchHandler = (selectors, clickedSelector, sizeToSet, textDecorationClass) => {
    const fontSizeCss = {
        property: 'font-size',
        small: '100%',
        medium: '120%',
        large: '140%',
    };
    const mainNavCss = {
        property: 'top',
        small: '2.8em',
        medium: '2.7em',
        large: '2.6em',
    };
    const searchNavCss = {
        property: 'top',
        small: '8.4em',
        medium: '7.4em',
        large: '6.6em',
    };

    jQuery(`${selectors.fontSizeSmall}, ${selectors.fontSizeMedium}, ${selectors.fontSizeLarge}`).removeClass(textDecorationClass);
    jQuery(selectors.body).css(fontSizeCss.property, fontSizeCss[sizeToSet]);
    jQuery(selectors.mainNav).css(mainNavCss.property, mainNavCss[sizeToSet]);
    jQuery(selectors.searchNav).css(searchNavCss.property, searchNavCss[sizeToSet]);
    jQuery(clickedSelector).addClass(textDecorationClass);
};

export const enableFontSizeSwitcher = () => {
    const selectors = {
        body: 'body',
        mainNav: '#main-navbar.has-image',
        searchNav: '#search-nav-bar',
        fontSizeSmall: '#font-size-small',
        fontSizeMedium: '#font-size-medium',
        fontSizeLarge: '#font-size-large',
    };
    const fontSizes = {
        small: 'small',
        medium: 'medium',
        large: 'large',
    };

    const textDecorationClass = 'text-underline';

    jQuery(selectors.fontSizeSmall).click(() => {
        fontSizeSwitchHandler(selectors, selectors.fontSizeSmall, fontSizes.small, textDecorationClass);
    });

    jQuery(selectors.fontSizeMedium).click(() => {
        fontSizeSwitchHandler(selectors, selectors.fontSizeMedium, fontSizes.medium, textDecorationClass);
    });

    jQuery(selectors.fontSizeLarge).click(() => {
        fontSizeSwitchHandler(selectors, selectors.fontSizeLarge, fontSizes.large, textDecorationClass);
    });

    jQuery(selectors.fontSizeSmall).addClass(textDecorationClass);
};